export enum RadarDetectionParamDirection {
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
}
